import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

// from https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
//const PASSWORD_REGEX =/^.*(?=.{8,50})(?=.*[a-zA-Z])(?=.*\d)(?=.*[!#$%&?."]).*$/  //special characters listed
const PASSWORD_REGEX =/^.*(?=.{8,50})(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W-_]).*$/   // all special characters + "_"

export class TmValidators {
  static email(control: AbstractControl): ValidationErrors | null {
      const email = control.value;
      const valid = EMAIL_REGEX.test(email);
  
      return email && !valid ? { email: true } : null;
  }
  
  static required(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
  
    const validateError = !value || value.trim() === ''
  
    return validateError ? { required: true } : null;
  }

  static passwordsMatch(group: FormGroup): ValidationErrors | null {
      const control1 = group.controls['password1'];
      const control2 = group.controls['password2'];
      if (control1.value !== control2.value) {
         return {PasswordNoMatch: true};
      } else {
         return null;
      }
    }

  static passwordValidFormat(control: AbstractControl): ValidationErrors | null {
      const password = control.value;
      const valid = PASSWORD_REGEX.test(password);

      return password && !valid ? { password: true } : null;
  }
}
